import React from 'react';
import FrontBackWorkflow from './FrontBackWorkflow';
import StitchedClothsWorkflow from './StitchedClothsWorkflow';
import UpperBodyFashionCatalogueWorkflow from '../ecommerce-photoshoot/UpperBodyFashionCatalogueWorkflow';

export interface WorkflowDefinition {
    id: string;
    name: string;
    description: string;
    image: string;
    Component: React.ComponentType<any>;
}

export const WORKFLOWS: WorkflowDefinition[] = [
    {
        id: 'catalogue-generator',
        name: 'Ecommerce Photoshoot',
        description: 'Generate high-end fashion catalogue lookbooks from 3 garment views (Full, Close-up, Sleeveless) mapped onto premium model angles.',
        image: '/images/AI-workflow/Upper-body-catalogue.png',
        Component: UpperBodyFashionCatalogueWorkflow,
    },
    {
        id: 'front-back-shoot',
        name: 'Front & Back Shoot',
        description: 'Upload front and back images to generate professional photoshoot outputs.',
        image: '/images/AI-workflow/Front-back.webp',
        Component: FrontBackWorkflow,
    },
    {
        id: 'stitched-cloths',
        name: 'Stitched Cloths',
        description: 'Turn unstitched or dummy garments into properly stitched outfits with sleeves and neck (Indian wear style).',
        image: '/images/AI-workflow/Stitched.webp',
        Component: StitchedClothsWorkflow,
    },
];

